"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./_commonjsHelpers.js"),r=require('./../ext/prop-types/index.js').__require(),s=e.getDefaultExportFromCjs(r);exports.default=s;
//# sourceMappingURL=index.js.map
